/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type InternalDataSourceMatchSource =
  typeof InternalDataSourceMatchSource[keyof typeof InternalDataSourceMatchSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalDataSourceMatchSource = {
  ELECTORAL_ROLL: 'ELECTORAL_ROLL',
  COUNTY_COURT_JUDGEMENTS: 'COUNTY_COURT_JUDGEMENTS',
  NA: 'NA',
  CREDIT_LENDERS: 'CREDIT_LENDERS',
  BT_OSIS: 'BT_OSIS',
  MORTALITY_DATA: 'MORTALITY_DATA',
} as const;
